import React from 'react';

import withPageComponents from '../../page/components/with-page-components';
import SeoMeta from '../../page/components/seo-meta';
import { getPDPTitle, getProductDescription } from '../seo-helpers';

const mapSEOData = (product, seo, pathname, storeDomain) => {
    const title = getPDPTitle(product);
    const description = getProductDescription(product);
    const canonical = seo.canonical || `https://${storeDomain}${pathname}`;
    const keywords = seo.keywords;
    return {
        ...seo,
        title,
        description,
        canonical,
        keywords
    }
}

export default withPageComponents(({ product, seo, url, storeDomain }) => {
    if (product) {
        return <SeoMeta seo={mapSEOData(product, seo, url, storeDomain)} />
    }
    return null;
}, { components: ['product'], storeDomain: true });